import { css } from "styled-components";

export const animationsCss = css`
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .blinking {
    animation: blink 1s linear infinite;
  }
`;
